

import React from 'react';
import Box from '@mui/material/Box';
import { reduxForm } from 'redux-form';
import { nanoid } from 'nanoid'
import { useDispatch, useSelector } from "react-redux";
import Button from '@mui/material/Button';
import FormBuilder, { IMedAppFormField } from '../../../form';
import { Feed } from '../../../../models';
import { required, minLength, email } from '../../../form/utils/validations';
import { createModel } from '../../store/actions';
import { selectCreatingModel } from '../../store/selectors';
import LinearProgress from '@mui/material/LinearProgress';

import medAppApi from '../../../../api/medAppApi';
import { useCreateFeed } from './feed-hooks';
import { putMessage } from '../../../app/store/actions';
const FeedCreateForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const FeedCreateReduxForm = reduxForm<any, any>({
    form: 'feed-create',
})(FeedCreateForm);


const FeedCreate: React.FC<{
    feed?: Feed
}> = ({ feed }) => {
 const codePrepend = nanoid(6).toUpperCase();
    const dispatch = useDispatch()
    const createFeed = useCreateFeed()

    const fields: IMedAppFormField[] = React.useMemo(() => ([
        {
            name: 'image',
            label: 'Feed Image',
            type: 'file',
            validate: [required],
            variant: 'file',

        },
        {
            name: 'title',
            label: 'Title',
            type: 'text',
            validate: [required, minLength(2)],

        },
        {
            name: 'excerpt',
            label: 'Feed excerpt',
            type: 'text',
            validate: [required],
            inputExtras: {
                multiline: true,
            }
        },

        {
            name: 'divider',
        
            type: 'text',
            variant: 'divider',
        },
        {
            name: 'body',
            label: 'Feed Content',
            type: 'text',
            inputExtras: {
    
                multiline: true,
            },
            

        },

 
        
    ]), [codePrepend]);


    
    const handleSubmit = (value: any) => {
        const data = {...value, codePrepend}
        createFeed.mutate(data, {
            onSuccess: () => {
                dispatch(putMessage({
                    type: 'success',
                    message: 'Successfully created feed'
                }))
            }, onError: () => {
                dispatch(putMessage({
                    type: 'error',
                    message: 'Something went wrong'
                }))
            }
        })
        
        console.log(data)
    }

    
    return (
        <Box style={{
            width: '100%'
        }}>
            <Box sx={{
                width: '70%',
                maxWidth: '700px',
                minWidth: '250px',
                marginLeft: '1em'
            }}>
                {(createFeed.isLoading) && <LinearProgress />}
                <FeedCreateReduxForm mFields={fields} namel="kosy-2" onSubmit={handleSubmit} />
            </Box>
        </Box>
    )
};

export default FeedCreate;